import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// EMPLOYEE EXIT REPORT RELATED APIs
// ==============================================

// 1. Get Employee Exit Report by Date Range
export const getEmpExit = async (params) => {
    try {
        const { fromDate, toDate } = params;
         // DEBUG
        
        // Validate required parameters
        if (!fromDate) {
            throw new Error('FromDate is required');
        }
        if (!toDate) {
            throw new Error('ToDate is required');
        }
        
        const queryParams = new URLSearchParams({
            Fromdate: fromDate.toString().trim(),
            Todate: toDate.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetEmpExit?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Employee Exit Report Details by ID
export const getReportEmpExitById = async (params) => {
    try {
        const { empRefNo, id, roleId } = params;
         // DEBUG
        
        // Validate required parameters
        if (!empRefNo) {
            throw new Error('EmpRefNo is required');
        }
        if (!id) {
            throw new Error('Id is required');
        }
        if (!roleId) {
            throw new Error('RoleId is required');
        }
        
        const queryParams = new URLSearchParams({
            Emprefno: empRefNo.toString().trim(),
            Id: id.toString().trim(),
            RoleId: roleId.toString().trim()
        });
        
         // DEBUG
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetReportEmpExitbyId?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};